module.exports = __webpack_public_path__ + "img/logo-5.574f4d6b.png";